import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import Avatar from '@/components/avatar/Index.vue';
import PagePreviewWithFormMixin from '@/helpers/vue_mixins/v2/PagePreviewWithFormMixin';
import { DIY } from '@/helpers/constants/Store';
import { Getter } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import TheClosePreviewTemplate from '@/components/v2/diy/TheClosePreviewTemplate';
let ConnectPagePreview = class ConnectPagePreview extends Mixins(PagePreviewWithFormMixin, ViewportSizeMixin) {
    get headerImgPath() {
        return require('@/assets/images/mobile-layout-header.svg');
    }
    get defaultGreeting() {
        return `Hi User! Thank you for checking us out. Click the Get Started
      button below to help you find the best deals in town!`;
    }
    get greeting() {
        return this.pageGreeting || this.defaultGreeting;
    }
};
__decorate([
    Getter('pageGreeting', { namespace: DIY })
], ConnectPagePreview.prototype, "pageGreeting", void 0);
ConnectPagePreview = __decorate([
    Component({
        components: {
            Avatar,
            TheClosePreviewTemplate,
        },
    })
], ConnectPagePreview);
export default ConnectPagePreview;
